import { BRAND, CONTACT } from "@/data/content";

export default function Confidentialite() {
  return (
    <div data-testid="confidentialite-page" className="bg-white">
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-8">Politique de confidentialité</h1>
          <div className="space-y-8 text-slate-600 leading-relaxed">
            <p>
              {BRAND.name} accorde une grande importance à la protection de vos données personnelles.
              Cette politique explique quelles données nous collectons et comment nous les utilisons.
            </p>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Données collectées</h2>
              <p>
                Via notre formulaire de contact et notre diagnostic, nous pouvons collecter : nom, prénom,
                nom du commerce, téléphone, email, type d'activité et le message que vous nous adressez,
                ainsi que les réponses au diagnostic de visibilité.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Utilisation des données</h2>
              <p>
                Ces données sont utilisées uniquement pour répondre à votre demande, vous recontacter et
                vous proposer un accompagnement adapté. Elles ne sont jamais vendues à des tiers.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Conservation</h2>
              <p>
                Vos données sont conservées le temps nécessaire au traitement de votre demande et à la
                relation commerciale, puis supprimées sur demande ou à l'issue d'un délai raisonnable.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression
                de vos données. Pour exercer ces droits, contactez-nous à : {CONTACT.email}.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Cookies</h2>
              <p>
                Ce site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement et,
                le cas échéant, des outils de mesure d'audience anonymisés.
              </p>
            </div>
            <p className="text-sm text-slate-400">Dernière mise à jour : {new Date().getFullYear()}.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
